import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';
import { getBreadcrumbConfig, generateBreadcrumbSchema } from '../config/breadcrumbConfig';

const Breadcrumb = () => {
  const location = useLocation();
  const currentPath = location.pathname;
  
  // Don't show breadcrumb on homepage
  if (currentPath === '/') return null;
  
  const config = getBreadcrumbConfig(currentPath);
  const { breadcrumb } = config;
  
  // Don't show if only Home (shouldn't happen since we check for '/')
  if (breadcrumb.length <= 1) return null;
  
  // Generate structured data
  const breadcrumbSchema = generateBreadcrumbSchema(breadcrumb);
  
  return (
    <>
      {/* JSON-LD Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify(breadcrumbSchema, null, 2)}
      </script>
      
      {/* Visible Breadcrumb */}
      <nav 
        className="bg-gradient-to-r from-gray-50 to-white dark:from-gray-800 dark:to-gray-900 border-b border-gray-200 dark:border-gray-700"
        aria-label="Breadcrumb"
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="py-3 md:py-4">
            <ol className="flex items-center space-x-1 md:space-x-2 overflow-x-auto whitespace-nowrap">
              {breadcrumb.map((item, index) => {
                const isLast = index === breadcrumb.length - 1;
                
                return (
                  <li key={item.path} className="flex items-center">
                    {index === 0 ? (
                      <Home className="h-4 w-4 md:h-5 md:w-5 text-gray-400" aria-hidden="true" />
                    ) : (
                      <ChevronRight 
                        className="h-4 w-4 md:h-5 md:w-5 text-gray-400 mx-1 md:mx-2 flex-shrink-0" 
                        aria-hidden="true" 
                      />
                    )}
                    
                    {isLast ? (
                      <span 
                        className="ml-2 text-sm md:text-base font-medium text-blue-600 dark:text-blue-400"
                        aria-current="page"
                      >
                        {item.label}
                      </span>
                    ) : (
                      <Link
                        to={item.path}
                        className="ml-2 text-sm md:text-base font-medium text-gray-500 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 transition-colors duration-200"
                      >
                        {item.label}
                      </Link>
                    )}
                  </li>
                );
              })}
            </ol>
          </div>
        </div>
      </nav>
    </>
  );
};

export default Breadcrumb;